// extracted by mini-css-extract-plugin
export var dateLabel = "_4f-0";
export var dateLabelError = "_4f-1";
export var fullWidth = "_4f-2";
export var smaller = "_4f-3";